import fetchPost from "../util/fetchpost"

export function userSetProfile(
    name: string,
    favoriteColor: number,
    showReplay: boolean,
): Promise<any> {
    return fetchPost(
        '/api/user/setprofile',
        { name, favoriteColor, showReplay },
    );
}

export function userChangePassword(
    oldPassword: string,
    newPassword: string,
): Promise<any> {
    return fetchPost(
        '/api/user/changepassword',
        { oldPassword, newPassword },
    );
}
export function userChangePasswordWithJwt(
    userId: number,
    token: string,
    newPassword: string,
): Promise<any> {
    return fetchPost(
        '/api/user/changepasswordwithjwt',
        { userId, token, newPassword },
    );
}

export function userChangeEmail(
    email: string,
    password: string,
): Promise<any> {
    return fetchPost(
        '/api/user/changeemail',
        { email, password },
    );
}

export function verifyEmail(
    email?: string,
): Promise<any> {
    return fetchPost(
        '/api/user/sendverifyemail',
        { email },
    );
}

export function setReplayForGame(
    gameId: number,
    showReplay: boolean,
): Promise<any> {
    return fetchPost(
        '/api/user/setreplayforgame',
        { gameId, showReplay }
    );
}

export function userSetPushSubscription(
    endpoint: string,
    subscription: string,
): Promise<any> {
    return fetchPost(
        '/api/user/setpushsubscription',
        { endpoint, subscription }
    );
}
